import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import HomeLayer from "../components/HomeLayer";

const HomePage = () => (
  <MasterLayout pageTitle="Home">
    <HomeLayer />
  </MasterLayout>
);

export default HomePage;
